import React, { useState,useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2';
import {forgotPassword} from '../../api/apiHandler'

const schema = yup.object().shape({
    email: yup.string().required("Please enter email").email("Please enter valid email address")
  });

export default function ForgotPassword() {
    const navigate=useNavigate()  

      const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(schema),
      });
      
      const onSubmit = (data) => {
        console.log("Data find")
        console.log({ data});
        forgotPasswordAPI(data)
        

      };

       // Frogot Password API calling 
  const forgotPasswordAPI=(data)=>{
    forgotPassword({"email":data.email}).then((resposnse)=>{
        console.log(resposnse)
        if(resposnse.data.code==1){
            Swal.fire(
                'Food For Good',
                'Your updated password sent to your register email',
                'success'
              ).then(() => {
                navigate("/sign-in")
              })
        }else{
            Swal.fire(
                'Food For Good',
                resposnse.data.message,
                'error'
            )
        }
    }); 
  } 
return (
<div className="authentication">
    <div className="card">
        <div className="body">
            <div className="row">
                <div className="col-lg-12">
                    <div className="header slideDown">
                        <div className="logo"><img src={process.env.PUBLIC_URL+"/assets/images/logo-2.png"} alt="Nexa"/></div>
                        <h1>School Panel</h1>
                    </div>                        
                </div>
                <form className="col-lg-12" id="form_validation" onSubmit={handleSubmit(onSubmit)} >
                    <h5 className="title">Forgot Password?</h5>
                    <small className="msg">Enter your e-mail address below to reset your password.</small>
                    <div className="form-group form-float">
                        <div className="form-line">
                            <input type="text" className="form-control"  id="email" placeholder='Email' name="email" {...register("email")}  />
                        </div>
                        <label className="errorc" >{errors.email?.message}</label>
                    </div>
                    <div className="col-lg-12">
                        <button className="btn btn-raised btn-primary waves-effect" type="submit">RESET MY PASSWORD</button>
                    </div>
                    <div className="col-lg-12 m-t-20">
                        <Link to="/sign-in" title="">Sign In!</Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
  )
}
